export function DocumentsWorkspace({ render }) {
  return render();
}

// Offers, sales orders and delivery notes share the deployed document workspace.
export const OffersPage = DocumentsWorkspace;
export const SalesOrdersPage = DocumentsWorkspace;
export const DeliveryNotesPage = DocumentsWorkspace;
